import React from "react";

const MAP = {
  // shared
  draft: "bg-slate-100 text-slate-700",
  canceled: "bg-slate-200 text-slate-600",
  cancellation_requested: "bg-amber-100 text-amber-800",
  refunded: "bg-slate-200 text-slate-600",
  partially_refunded: "bg-slate-200 text-slate-600",
  disputed: "bg-red-100 text-red-700",
  completed: "bg-emerald-100 text-emerald-800",

  // Booking
  payment_pending: "bg-amber-100 text-amber-800",
  awaiting_provider_response: "bg-sky-100 text-sky-800",
  confirmed: "bg-sky-100 text-sky-800",
  requirements_needed: "bg-amber-100 text-amber-800",
  scheduled: "bg-indigo-100 text-indigo-800",
  provider_traveling: "bg-indigo-100 text-indigo-800",
  provider_arrived: "bg-indigo-100 text-indigo-800",
  in_progress: "bg-teal-100 text-teal-800",
  paused: "bg-slate-100 text-slate-700",
  awaiting_expense_approval: "bg-amber-100 text-amber-800",
  awaiting_customer_completion_approval: "bg-amber-100 text-amber-800",
  rescheduled: "bg-indigo-100 text-indigo-800",

  // Order
  delivered: "bg-emerald-50 text-emerald-800",
  revision_requested: "bg-amber-100 text-amber-800",
  revised: "bg-emerald-50 text-emerald-800",

  // Requests / proposals
  pending_review: "bg-amber-100 text-amber-800",
  published: "bg-emerald-100 text-emerald-800",
  receiving_proposals: "bg-emerald-100 text-emerald-800",
  provider_selected: "bg-indigo-100 text-indigo-800",
  submitted: "bg-sky-100 text-sky-800",
  shortlisted: "bg-indigo-100 text-indigo-800",
  changes_requested: "bg-amber-100 text-amber-800",
  declined: "bg-slate-200 text-slate-600",
  accepted: "bg-emerald-100 text-emerald-800",
  expired: "bg-slate-200 text-slate-600",
  withdrawn: "bg-slate-200 text-slate-600",

  // offers
  sent: "bg-sky-100 text-sky-800",

  // turnover plans
  pending_provider: "bg-amber-100 text-amber-800",
  paused: "bg-slate-200 text-slate-600",
};
const LABELS = { pending_provider: "waiting for cleaner" };

export default function StatusPill({ status, size = "sm" }) {
  const cls = MAP[status] || "bg-slate-100 text-slate-700";
  const sz = size === "lg" ? "px-3 py-1.5 text-[12px]" : "px-2.5 py-1 text-[11px]";
  return (
    <span
      data-testid={`status-pill-${status}`}
      className={`inline-flex items-center rounded-full font-medium capitalize ${sz} ${cls}`}
    >
      {LABELS[status] || (status || "").replace(/_/g, " ")}
    </span>
  );
}
